import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'
import tabView from './modules/tabView'
import getters from './modules/getters'
Vue.use(Vuex)
const state = {
  level1Menu: [],
  id: '',
  // visitedViews: [],
  meunList: [], // 菜单
  type: '', // 注册类型
  companyType: '',
  agentCompanyId: '', //代理商Id
  codeInfo: '',
}
const mutations = {
  GET_level1Menu(state, list) {
    state.level1Menu = list
  },
  GET_ID(state, id) {
    state.id = id
  },
  GET_MENULIST(state, list) {
    state.meunList = list
  },
  GET_TYPE(state, type) {
    state.type = type
  },
  GET_COMPANYTYPE(state, companyType) {
    state.companyType = companyType
  },
  GET_AGENTID(state, agentCompanyId) {
    state.agentCompanyId = agentCompanyId
  },
  SET_CODEINFO(state, codeInfo) {
    state.codeInfo = codeInfo
  },
}

const actions = {
  getlevel1Menu({ commit }, list) {
    commit('GET_level1Menu', list)
  },
  getID({ commit }, id) {
    commit('GET_ID', id)
  },
  getmeunList({ commit }, list) {
    commit('GET_MENULIST', list)
  },
  getType({ commit }, type) {
    commit('GET_TYPE', type)
  },
  getCompanyType({ commit }, companyType) {
    commit('GET_COMPANYTYPE', companyType)
  },
  getAgentId({ commit }, agentCompanyId) {
    commit('GET_AGENTID', agentCompanyId)
  },
  setCodeInfo({ commit }, codeInfo) {
    commit('SET_CODEINFO', codeInfo)
  },
}



export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules:{
    tabView,
    tagsView,
    getters
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js